import { Link } from 'react-router-dom';
import MovieCard from '@/components/feature/MovieCard';
import type { Movie } from '@/mocks/movies';

interface FeaturedSectionProps {
  title: string;
  movies: Movie[];
  viewAllLink?: string;
}

export default function FeaturedSection({ title, movies, viewAllLink }: FeaturedSectionProps) {
  return (
    <section className="px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-800">
            {title}
          </h2>
          {viewAllLink && (
            <Link
              to={viewAllLink}
              className="flex items-center gap-1 text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
            >
              查看全部
              <i className="ri-arrow-right-s-line"></i>
            </Link>
          )}
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-3 md:gap-4" data-product-shop>
          {movies.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      </div>
    </section>
  );
}